const firebaseConfig = {
  apiKey: "AIzaSyAu_gtNY_HzDfNfsr8AbxOFOogoPIHwwrY",
  authDomain: "linkit-d9729.firebaseapp.com",
  projectId: "linkit-d9729",
  storageBucket: "linkit-d9729.appspot.com",
  messagingSenderId: "963588110464",
  appId: "1:963588110464:web:e4f979746065e0f6d34e65",
  measurementId: "G-NF1EHGPCL0"
};

export default firebaseConfig;